module.exports = __webpack_public_path__ + "assets/add-icon-mini.8a0e8bf6.svg";